import React, { useEffect } from 'react'
import { Spin } from 'antd'
import "./room.scss"
import { useTranslation } from 'react-i18next'
import { useNavigate } from "react-router-dom"
import { AppDispatch, RootState } from '../../../store'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationRoom, fetchRooms, idleRooms } from './redux/roomSlice'
import { list } from '../../data/Data'

interface Props {
  applicationId: string
  mode?: 'home' | 'full'
}

const getRoomTypeName = (type: number | undefined, t: (key: string) => string) => {
  switch (type) {
    case 0:
      return t('Big Double Room')
    case 1:
      return t('Double Room')
    case 2:
      return t('Master Room')
    case 3:
      return t('Lodging')
    case 4:
      return t('Family Room')
    case 5:
      return t('Big Simple Room')
    default:
      return t('Simple Room')
  }
}

function RoomCard({ applicationId, mode = 'full' }: Props) {
  const dispatch: AppDispatch = useDispatch()
  const { t } = useTranslation('rooms')
  const navigate = useNavigate()
  const apiURL = process.env.REACT_APP_API_URL
  const roomsFromRedux = useSelector((state: RootState) => state.room.rooms)
  const fetchRoomsStatus = useSelector((state: RootState) => state.room.fetchRoomsStatus)

  const redirectToServicePage = (id: string | undefined) => {
    navigate(`/rent/${id}`)
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    if (apiURL !== "https://aucoeur-back-main.onrender.com") {
      dispatch(fetchRooms({ applicationId }))
    }
    return () => {
      dispatch(idleRooms())
    }
  }, [applicationId, dispatch, apiURL])

  const allRooms = apiURL === "https://aucoeur-back-main.onrender.com" ? list : roomsFromRedux

  const rooms = (() => {
    if (mode !== 'home') return allRooms
    const total = allRooms.length
    if (total > 4) return allRooms.slice(0, 4)
    if (total >= 2 && total <= 3) return allRooms.slice(0, 2)
    return allRooms
  })()

  const getImages = (cover: string, additionalImages: string[] | undefined): string[] => {
    return additionalImages ? [cover, ...additionalImages] : [cover]
  }

  return (
    <div className='content grid2 mtop'>
      {rooms.map((val: ApplicationRoom, index: number) => {
        const { name, _id, cover, active, capacity, numBeds, type } = val
        const coverImg = cover ? cover : "../images/additional/chambre1.jpg"
        const roomTypeName = getRoomTypeName(type, t)

        return (
          <div
            className="room-card"
            key={index}
            onClick={() => redirectToServicePage(_id)}
          >
            <img src={coverImg} alt={`${roomTypeName} ${name || ''}`} className="room-image" />
            <div className="room-card__overlay" />
            <div className="room-card__status" data-active={active}>
              {active ? t('Available') : t('Unavailable')}
            </div>
            <div className="room-card__content">
              <h3 className="room-card__name">{name}</h3>
              <span className="room-card__type">{roomTypeName}</span>
              <div className="room-card__details">
                <span>{capacity} {t('people')}</span>
                <span className="room-card__dot" />
                <span>{numBeds} {t('beds')}</span>
              </div>
              <button
                type="button"
                className="room-card__cta"
                onClick={(e) => {
                  e.stopPropagation()
                  redirectToServicePage(_id)
                }}
              >
                {t('View')}
              </button>
            </div>
          </div>
        )
      })}
      {fetchRoomsStatus !== 'success' && apiURL !== "https://aucoeur-back-main.onrender.com" && (
        <div className="loading-container">
          <Spin />
        </div>
      )}
    </div>
  )
}

export default RoomCard
